<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <h5>查询条件</h5>
          </div>
          <div class="card-body">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-input
                  v-model="groupBuyManageInfo.conditions.groupProdName"
                  placeholder="请输入拼团商品名称"
                  clearable
                />
              </el-col>
              <el-col :span="8">
                <el-input
                  v-model="groupBuyManageInfo.conditions.batchId"
                  placeholder="请输入批次编号"
                  clearable
                />
              </el-col>
              <el-col :span="6">
                <el-input
                  v-model="groupBuyManageInfo.conditions.buyId"
                  placeholder="请输入订单号"
                  clearable
                />
              </el-col>
              <el-col :span="4">
                <el-button type="primary" @click="_queryProductMethod">
                  <i class="el-icon-search"></i> 查询
                </el-button>
                <el-button @click="_resetProductMethod">
                  <i class="el-icon-refresh"></i> 重置
                </el-button>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <h5>拼团列表</h5>
          </div>
          <div class="card-body">
            <el-table
              :data="groupBuyManageInfo.products"
              border
              style="width: 100%"
            >
              <el-table-column prop="persionId" label="用户ID" align="center" />
              <el-table-column prop="persionName" label="用户名称" align="center" />
              <el-table-column prop="groupProdName" label="拼团名称" align="center" />
              <el-table-column prop="groupId" label="拼团ID" align="center" />
              <el-table-column prop="buyId" label="订单号" align="center" />
              <el-table-column prop="buyCount" label="拼团数量" align="center" />
              <el-table-column prop="amount" label="付款金额" align="center" />
              <el-table-column prop="stateName" label="状态" align="center" />
            </el-table>

            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next, jumper"
              :total="total"
              class="pagination"
            >
            </el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryGroupBuy } from '@/api/goods/groupBuyManage/groupBuyManageApi'

export default {
  name: 'GroupBuyManage',
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      groupBuyManageInfo: {
        products: [],
        conditions: {
          groupProdName: '',
          batchId: '',
          buyId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._initMethod()
  },
  methods: {
    _initMethod() {
      const batchId = this.$route.query.batchId
      if (batchId) {
        this.groupBuyManageInfo.conditions.batchId = batchId
      }
      this._listProducts(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _listProducts(page, rows) {
      this.groupBuyManageInfo.conditions.page = page
      this.groupBuyManageInfo.conditions.row = rows
      const params = {
        ...this.groupBuyManageInfo.conditions,
        groupProdName: this.groupBuyManageInfo.conditions.groupProdName.trim(),
        batchId: this.groupBuyManageInfo.conditions.batchId.trim(),
        buyId: this.groupBuyManageInfo.conditions.buyId.trim()
      }

      queryGroupBuy(params)
        .then(response => {
          this.groupBuyManageInfo.products = response.data
          this.total = response.records
          this.currentPage = page
        })
        .catch(error => {
          console.error('请求失败:', error)
        })
    },
    _queryProductMethod() {
      this._listProducts(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _resetProductMethod() {
      this.groupBuyManageInfo.conditions = {
        groupProdName: '',
        batchId: '',
        buyId: '',
        page: 1,
        row: 10
      }
      this._listProducts(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    handleCurrentChange(val) {
      this._listProducts(val, this.DEFAULT_ROWS)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>